<template>
  <div class="row blaChooserContainer">
    <Loader :show="showLoader" />

    <div class="col-12 col-md-8 offset-md-2">
      <div class="row">
        <div class="col-12">
          <div v-if="user" class="blaChooserTitle">
            <!-- Üdvözlünk <br />
            {{ user.name }}, <br /> -->
            Ma mivel fejlődjünk?
          </div>
        </div>
      </div>
      <div class="row p-2">
        <div
          v-for="(course, index) in courses"
          :key="index"
          class="col-12 mb-3 blaChooserItem clickable"
          :class="selectChooserColor(course)"
          @click="goToStepField(course.id)"
        >
          <div class="row align-center mt-2">
            <div class="col-5 col-md-12 text-center d-inline-block">
              <img
                v-if="course.icon_type === 0"
                :src="require('@/assets/img/kurzus_hang.png')"
                alt="kurzus_hang"
                class="img-fluid blaChooserItemImg"
              />
              <img
                v-else-if="course.icon_type === 1"
                :src="require('@/assets/img/kurzus_video.png')"
                alt="kurzus_video"
                class="img-fluid blaChooserItemImg"
              />
              <img
                v-else
                :src="require('@/assets/img/kurzus_teszt.png')"
                alt="kurzus_teszt"
                class="img-fluid blaChooserItemImg"
              />
            </div>
            <div class="col-7 col-md-12 d-inline-block py-2 mt-3">
              <div class="blaChooserAlt">{{ course.title }}</div>
              <div class="blaChooserScore my-4 my-md-5">
                <!-- Teljesítve: -->
                <!-- <strong> {{ course.userItem }}/{{ course.allItem }} </strong> -->
                <!-- <br /> -->
                <!-- Lingron: -->
                <!-- <strong> -->
                <!-- {{ course.userLingron }}/{{ course.allLingron }} -->
                <!-- </strong> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loader from '@/components/partials/Loader';

export default {
  components: { Loader },
  data: () => ({
    user: {},
    courses: {},
    onlyFree: false,
    showLoader: true
  }),
  methods: {
    getChooserdData() {
      this.$store.commit('setCourseId', {
        courseId: 0
      });

      this.$store.commit('setSubscriptionId', {
        subscriptionId: 0
      });

      axios
        .post(this.$store.getters.getApiUrl + '/api/chooser', {
          token: this.$store.getters.getToken,
          userId: this.user.id
        })
        .then(response => {
          this.courses = response.data.courses;
          this.onlyFree = response.data.only_free;

          let v = this;
          setTimeout(function() {
            v.showLoader = false;
          }, 10);
        })
        .catch(error => {
          if (error) {
            console.error('stepfield- error: ', error);
          }
        });
    },
    selectChooserColor(course) {
      switch (course.icon_type) {
      case 0:
        return 'blaChooserItemBlue';
      case 1:
        return 'blaChooserItemPurple';
      case 2:
        return 'blaChooserItemRed';
      }
    },
    goToStepField(courseId) {
      this.$store.commit('setCourseId', {
        courseId: courseId
      });

      this.$router.push({ name: 'home' });
    },
    goToOffer() {
      window.open(this.$data.offerUrl, '_blank');
    },
    goToBuyLink() {
      this.$router.push({ name: 'packages' });
      // window.open(this.$data.sapBuyerLink, "_blank");
    }
  },
  mounted() {
    //Get user data from localstore
    this.user = this.$store.getters.currentUser;

    //Get chooser data
    this.getChooserdData();
  }
};
</script>
